import { defineComponent as _defineComponent } from 'vue'
import {
  computed, PropType, ref, watch,
} from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ValidatedTextField',
  props: {
    validationMode: { type: String, required: false, default: 'aggressive' },
    value: { type: String, required: true },
    rules: { type: String, required: false, default: '' },
    label: { type: String, required: false, default: '' },
    type: { type: String, required: false, default: 'text' },
    prefix: { type: Object as PropType<string | Array<string>>, required: false, default: undefined },
    hidePrefixOnBlur: { type: Boolean, required: false, default: false },
    stripPrefixFromValue: { type: Boolean, required: false, default: false },
  },
  emits: ["input", "focus", "blur"],
  setup(__props, { emit }: { emit: ({(e: 'input', value: string): void,
  (e: 'focus', event: any): void
  (e: 'blur', event: any): void
}), expose: any, slots: any, attrs: any }) {

const props = __props;





const val = ref(props.value);
// eslint-disable-next-line no-nested-ternary
const chosenPrefix = ref(props.stripPrefixFromValue
  ? (typeof props.prefix === 'string' ? props.prefix : props.prefix[0])
  : undefined);

watch(() => props.value, () => {
  if (props.stripPrefixFromValue && props.value === chosenPrefix.value + val.value) {
    return;
  }
  val.value = props.value;
});

watch(val, () => {
  if (props.stripPrefixFromValue && val.value && val.value.length > 0) {
    if (typeof props.prefix === 'string') {
      val.value = val.value.replace(props.prefix, '');
    } else {
      const prefix = props.prefix.find((p) => val.value.startsWith(p)) ?? chosenPrefix.value;
      chosenPrefix.value = prefix;
      val.value = val.value.replace(prefix!, '');
    }
    emit('input', chosenPrefix.value + val.value);
    return;
  }
  emit('input', val.value);
});

const focused = ref(false);
const onFocus = (event: any) => { focused.value = true; emit('focus', event); };
const onBlur = (event: any) => { focused.value = false; emit('blur', event); };

const computedPrefix = computed(() => {
  if (!props.hidePrefixOnBlur) { return chosenPrefix.value; }
  if (props.hidePrefixOnBlur && (focused.value || (val.value ?? '').length > 0)) {
    return chosenPrefix.value;
  }
  return undefined;
});


return { __sfc: true,props, emit, val, chosenPrefix, focused, onFocus, onBlur, computedPrefix }
}

})